import AddNew from '@/brain/record/document-type/add-new'
import ListPaginated from '@/brain/record/document-type/list-paginated'
import EditRegister from '@/brain/record/document-type/edit-register'
import RemoveRegister from '@/brain/record/document-type/remove-register'

const state = {
  documentTypes: [],
  pagination: {
    skip: 0,
    limit: 100
  }
}
const getters = {
  LIST: state => state.documentTypes
}

const mutations = {
  SET_LIST: (state, list) => { state.documentTypes = list }
}

const actions = {
  ADD_NEW: AddNew,
  LIST_PAGINATED: ListPaginated,
  EDIT_REGISTER: EditRegister,
  REMOVE_REGISTER: RemoveRegister
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/record/document-type/state/index.js